import { useState } from "react";
import { useFetch } from "../../hooks/useFetch";
import { getProjects } from "../../services/firestore";
import { LoadingGrid } from "../ui/LoadingState";
import "./Projects.css";

const FILTERS = ["all", "web", "app", "game", "other"];

function ProjectCard({ project }) {
  return (
    <article className="project-card card">
      <div className="project-card__header">
        <span className="project-card__cat">{project.category || "other"}</span>
        <div className="project-card__right">
          {project.featured && <span className="project-card__featured">★ featured</span>}
          {project.github_url && (
            <a href={project.github_url} target="_blank" rel="noopener noreferrer" title="GitHub" aria-label={`${project.title} on GitHub`}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0 0 24 12c0-6.63-5.37-12-12-12z"/>
              </svg>
            </a>
          )}
          {project.live_url && (
            <a href={project.live_url} target="_blank" rel="noopener noreferrer" title="Live demo" aria-label={`${project.title} live demo`}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                <polyline points="15 3 21 3 21 9"/>
                <line x1="10" y1="14" x2="21" y2="3"/>
              </svg>
            </a>
          )}
        </div>
      </div>
      <h3 className="project-card__title">{project.title}</h3>
      <p className="project-card__desc">{project.description}</p>
      <div className="project-card__stack">
        {project.tech_stack?.map((t) => (
          <span key={t} className="badge">{t}</span>
        ))}
      </div>
    </article>
  );
}

export default function Projects() {
  const [filter, setFilter] = useState("all");
  const { data, loading, error } = useFetch(getProjects, []);

  const projects = data || [];
  const filtered = filter === "all" ? projects : projects.filter(p => p.category === filter);

  return (
    <section id="projects" className="section projects">
      <div className="container">
        <h2 className="section-title">
          <span className="section-title__index">03</span>
          Projects
        </h2>

        <div className="projects__filters">
          {FILTERS.map((f) => (
            <button
              key={f}
              className={`projects__filter-btn ${filter === f ? "projects__filter-btn--active" : ""}`}
              onClick={() => setFilter(f)}
            >
              {f}
            </button>
          ))}
        </div>

        {loading && <LoadingGrid count={3} height={280} />}

        {error && <p className="projects__error">Error: {error}</p>}

        {!loading && !error && (
          <div className="grid-3">
            {filtered.map((p) => <ProjectCard key={p.id} project={p} />)}
          </div>
        )}

        {!loading && !error && filtered.length === 0 && (
          <p className="projects__empty">No projects in this category yet.</p>
        )}
      </div>
    </section>
  );
}
